import React from 'react';
import styled from 'styled-components';

import defaultStyles from '../DefaultStyles';

import EditingContainerForBaseData from '../../../Pages/WeddingPage/Editing/Components/EditingContainer/EditingContainerForBaseData';
import BackgroundElementContainer from '../../Components/BackgroundElementContainer/BackgroundElementContainer';

import WeddingTitle from './Components/WeddingTitle';
import WeddingDate from './Components/WeddingDate';
import Countdown from '../Components/Countdown';
import StartPhoto from './Components/StartPhoto';
import Element from './Components/Element';
import useDynamicFontSize from '../../HookUtils/useDynamicFontSize';
import { Hidden } from '@material-ui/core';

const Container = styled.div`
  background-image: ${`radial-gradient(circle at 50% 80%, ${defaultStyles.blossom.background.colors[1]}, ${defaultStyles.blossom.background.colors[0]})`};
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  min-height: 100%;
  overflow: hidden;
`;

const WeddingTitleContainer = styled.div`
  position: absolute;
  top: 0;
  bottom: 60vh;
  left: 0;
  right: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const CustomLogo = styled.div`
  height: 350px;
  max-height: 25vh;
  width: 500px;
  max-width: 70vw;
  margin: auto;
  background-image: ${({ imageUrl }) => `url(${imageUrl})`};
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`;

const WeddingTitleInnerContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

const BlossomAppBackground = ({ showStartPage, weddingConfig }) => {
  const { nameOfBride, nameOfGroom, weddingDate } = weddingConfig;
  const { fontSize, textRef } = useDynamicFontSize(`${nameOfBride} & ${nameOfGroom}`);

  return (
    <Container>
      <BackgroundElementContainer>
        {showStartPage && (
          <Countdown weddingConfig={weddingConfig} weddingStyle={weddingConfig.weddingStyle}></Countdown>
        )}
        {weddingConfig.useStartPhoto && <StartPhoto imageUrl={weddingConfig.startPhotoUrl}></StartPhoto>}
        <Element visible reducedOpacity={!showStartPage}></Element>
        {showStartPage && weddingConfig && (
          <WeddingTitleContainer>
            {weddingConfig.useCustomLogo ? (
              <WeddingTitleInnerContainer>
                <CustomLogo imageUrl={weddingConfig.customLogoUrl}></CustomLogo>
                <EditingContainerForBaseData></EditingContainerForBaseData>
              </WeddingTitleInnerContainer>
            ) : (
              <WeddingTitleInnerContainer>
                {nameOfBride && nameOfGroom && (
                  <>
                    <Hidden smUp>
                      <WeddingTitle title={`${nameOfBride} & ${nameOfGroom}`}>
                        {nameOfBride} &amp; {nameOfGroom}
                      </WeddingTitle>
                    </Hidden>
                    <Hidden xsDown>
                      <WeddingTitle
                        ref={textRef}
                        style={{ fontSize: `${fontSize}px`, whiteSpace: 'nowrap' }}
                        title={`${nameOfBride} & ${nameOfGroom}`}
                      >
                        {nameOfBride} &amp; {nameOfGroom}
                      </WeddingTitle>
                    </Hidden>
                  </>
                )}
                <EditingContainerForBaseData>
                  <WeddingDate>{weddingDate}</WeddingDate>
                </EditingContainerForBaseData>
              </WeddingTitleInnerContainer>
            )}
          </WeddingTitleContainer>
        )}
      </BackgroundElementContainer>
    </Container>
  );
};

export default BlossomAppBackground;
